import { render } from "./CuponsManager.vue?vue&type=template&id=306e020a&scoped=true"
import script from "./CuponsManager.vue?vue&type=script&lang=js"
export * from "./CuponsManager.vue?vue&type=script&lang=js"

import "./CuponsManager.vue?vue&type=style&index=0&id=306e020a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306e020a"]])

export default __exports__